const misc = {
  reload: 'Reload Page',
  business: 'Business',
  first: 'First',
  last: 'Last',
  next: 'Next',
  edit: 'Edit',
  back: 'Back',
  submit: 'Submit',
  cancel: 'Cancel',
  continue: 'Continue',
  steps: 'Step {{ step }} of {{ totalSteps }}',
  week_view: "Week's view",
  total_view: "Total view",
  total_clicks: "Total Clicks",
  total_revenue: "Total revenue",
  add: 'Add',
  upload: 'Upload file',
  status: 'Status',
  network_error: 'It seems there\'s an error in your network connection',
  save: 'Save',
  address: 'Address',
  export: 'Export',
  csv: 'CSV',
  pdf: 'PDF',
  na: 'Not available',
    confirm_action: {
    1: 'You have triggered a ',
    2: ' action, do you wish to continue with this?',
  },
  description_na: 'Description not available',
  branch_details: 'Branch details',
  location: 'Location',
  edit_details: 'Edit details',
  view_details: 'View details',
  delete: 'Delete',
  total_transaction: 'Total transactions',
  logout_confirmation: 'Are you sure you want to log out of this app?',
  offline: {
    title: 'Connect to the internet',
    body: 'You\'re offline. Please check your internet connection.'
  },
  logout: {
    title: 'Logout',
    today: 'Today',
    days: 'Last 7 days',
    month: 'Last 30 days',
    all: 'All days',
    start: 'Start date',
    end: 'End date',
    success: 'Logout successful',
    failed: 'Logout successful'
  },
  validations: {
    required: 'Field is required',
    email: 'Must be a valid email address',
    phone: 'Must be a valid phone number',
    confirmed: 'Must match password',
    min: 'Contains at least {{ chars }} characters',
    caps: 'Contains at least one capital letter',
    nomail: 'Does not contain your name or email address',
    num: 'Contains at least one number (0-9) or symbol',
    number: 'Must contain only numbers',
    match: 'Passwords must match',
    url: 'Must be a valid website address (eg. http://example.com)'
  }
};

export default misc;